export class StaticRenderer {

    constructor(p_jstemplatecenter) {
        this.jstemplatecenter = p_jstemplatecenter;
    }

    render(p_document, p_templateName) {
        return this.jstemplatecenter.templates[p_templateName](p_document);
    }
}